import { FunctionComponent } from 'react';
import { Heading } from 'evergreen-ui';
import { AnchorComponent, LinkComponent } from '../../../../components/index';
import { Dispatch } from 'redux';
import { Environment } from 'services/Environment';

type BrowseSectionProps = {
    dispatch: Dispatch;
    setMobileMenuShown: (newValue: boolean) => void;
    uTMDetails: { [key: string]: string };
};

export const BrowseSection: FunctionComponent<BrowseSectionProps> = ({
    dispatch,
    setMobileMenuShown,
    uTMDetails,
}) => {
    return (
        <>
            <Heading>Browse</Heading>
            <ul>
                <li>
                    <LinkComponent
                        to="/"
                        onClick={() => {
                            window.scrollTo(0, 0);
                            //@ts-ignore - search.js needs updated to TS
                            dispatch(clearSearch());
                            setMobileMenuShown(false);
                        }}
                    >
                        Home
                    </LinkComponent>
                </li>
                <li>
                    <LinkComponent
                        to="/gift-checkout"
                        onClick={() => {
                            window.scrollTo(0, 0);
                            //@ts-ignore - search.js needs updated to TS
                            dispatch(clearSearch());
                            setMobileMenuShown(false);
                        }}
                    >
                        Vouchers
                    </LinkComponent>
                </li>
                <li>
                    <AnchorComponent
                        href={`${Environment.MARKETPLACE_URL}/for-educators`}
                        onClick={() => {
                            window.scrollTo(0, 0);
                            setMobileMenuShown(false);
                        }}
                    >
                        Partner with us
                    </AnchorComponent>
                </li>
                <li>
                    <AnchorComponent
                        href={`${Environment.MARKETPLACE_URL}/create-educator?${uTMDetails?.redirectRef}`}
                    >
                        Create a course
                    </AnchorComponent>
                </li>
                <li>
                    <LinkComponent
                        to="/about"
                        onClick={() => {
                            window.scrollTo(0, 0);
                            setMobileMenuShown(false);
                        }}
                    >
                        About us
                    </LinkComponent>
                </li>
                <li>
                    <LinkComponent
                        to="/contact"
                        onClick={() => {
                            window.scrollTo(0, 0);
                            setMobileMenuShown(false);
                        }}
                    >
                        Contact us
                    </LinkComponent>
                </li>
                <li>
                    <AnchorComponent
                        href="https://cademy.notion.site/Careers-at-Cademy-49b1d4dbefe14b2c971725b5e518166b"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        Careers
                    </AnchorComponent>
                </li>
                <li>
                    <AnchorComponent href={`${Environment.CADEMY_ROADMAP_URL}/changelog`}>
                        Company & Product Updates
                    </AnchorComponent>
                </li>
            </ul>
        </>
    );
};
